import TemplateView from '../TemplateView'

export default class UserInitialsIcon extends TemplateView {
    constructor({
        firstName,
        lastName,
        color = ''
    }) {
        super()

        this.params = {
            firstName,
            lastName,
            color
        }
    }

    templateHtml() {
        return "<div class='components_userInitialsIcon'><%-fnLetter%><%-lnLetter%></div>"
    }

    templateModel() {
        return {
            fnLetter: this.params.firstName[0],
            lnLetter: this.params.lastName[0],
            color: this.params.color,
        }
    }

    afterRender() {
        this.getEl().css('background-color', this.params.color)
    }
}


// WEBPACK FOOTER //
// ./web/js/components/UserInitialsIcon.js